import React, { useState } from "react";
import ScreenLoader from "../../../components/ScreenLoader";
import moment from "moment";

const SMBookedGameTable = ({ data }) => {
  const [loader, setLoader] = useState(false);

  // Validate if data is an array
  const isValidData = Array.isArray(data);

  return (
    <div className="card shadow mb-4">
      <div className="table-responsive">
        {isValidData ? (
          <table className="table table-bordered dataTable" width="100%">
            <thead>
              <tr className="bg-gray-300">
                <th>S.No.</th>
                <th>User Name</th>
                <th>Match Name</th>
                <th>Bet No.</th>
                <th>Amount</th>
                <th>IP</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? "even" : "odd"}>
                    <td>{index + 1}</td>
                    <td>{user.UserName}</td>
                    <td>{user.MatchName}</td>
                    <td>{user.betNo}</td>
                    <td>{user.Amount}</td>
                    <td>{user.IP_Address}</td>
                    <td>{moment(user.CreatedOn).format('DD-MM-YYYY h:mm A')}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
            {typeof data === "string" ? data : "Invalid data received"}
          </div>
        )}
      </div>
    </div>
  );
};

export default SMBookedGameTable;
